import { inject as inject$1 } from "vue";
let app;
const setCurrentApp = (instance) => {
  app = instance;
};
const getCurrentApp = () => app;
const inject = (key, value) => {
  var _a;
  const app2 = (_a = getCurrentApp()) == null ? void 0 : _a._context.provides[key];
  return app2 || inject$1(key, value);
};
export {
  getCurrentApp as g,
  inject as i,
  setCurrentApp as s
};
//# sourceMappingURL=current-app-1538613c.mjs.map
